/** Read nested string / number fields from unknown JSON without throwing. */
export function safeString(v: unknown, maxLen = 2000): string {
  if (v == null) return ''
  if (typeof v === 'string') return v.length > maxLen ? `${v.slice(0, maxLen)}…` : v
  if (typeof v === 'number' && Number.isFinite(v)) return String(v)
  if (typeof v === 'boolean') return v ? 'true' : 'false'
  return ''
}

export function pickFirstString(obj: Record<string, unknown> | null | undefined, keys: string[]): string {
  if (!obj) return ''
  for (const k of keys) {
    const v = obj[k]
    const s = safeString(v, 4000).trim()
    if (s) return s
  }
  return ''
}
